var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'l-ad--hide-all-amp-units': _vm.isHideAd === 'Y' }},[_c('HeaderAMP'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('FooterAMP')],1)}
var staticRenderFns = []

export { render, staticRenderFns }